var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2505 12.4811L14.2796 19.7479C13.8174 20.2295 13.1907 20.5 12.5371 20.5C11.8836 20.5 11.2569 20.2295 10.7947 19.7479L3.82374 12.4824C3.2475 11.887 2.78975 11.1789 2.47678 10.3987C2.16381 9.61843 2.00179 8.78145 2.00001 7.93578C1.99824 7.0901 2.15674 6.25239 2.46643 5.47073C2.77611 4.68907 3.23088 3.97886 3.80462 3.38088C4.37836 2.78289 5.05978 2.30891 5.80975 1.98614C6.55971 1.66337 7.36346 1.49816 8.17485 1.50002C8.98625 1.50187 9.78929 1.67074 10.5379 1.99693C11.2865 2.32312 11.9659 2.80021 12.5371 3.40081C13.6974 2.22161 15.2567 1.56633 16.8772 1.57692C18.4978 1.5875 20.0491 2.26309 21.1951 3.45735C22.3411 4.6516 22.9895 6.26835 22.9999 7.95736C23.0103 9.64638 22.3818 11.2717 21.2505 12.4811Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.9d42f1204f467270e62be203db2f9c5e.svg";
export { ForwardRef as ReactComponent };